import type { ButtonHTMLAttributes, ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface OnboardingSkipButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  /** Full width button (default: true) */
  fullWidth?: boolean
}

export function OnboardingSkipButton({
  children,
  className,
  fullWidth = true,
  type = 'button',
  ...props
}: OnboardingSkipButtonProps) {
  return (
    <button
      type={type}
      className={cn(
        'cursor-pointer py-2.5 text-center text-sm font-semibold text-[#535862] transition-colors hover:text-[#181d27]',
        fullWidth && 'w-full',
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}
